import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import get from 'lodash/get';
import ReactHtmlParser from 'react-html-parser';

import Button from 'rebook/apps/base/components/Button';
import ModalDialog from 'rebook/mybook/App/ModalDialogs/ModalDialog';
import ContentCarousel from 'rebook/apps/base/components/ContentCarousel';
import VerticalBookCard from 'rebook/apps/books/components/VerticalBookCard';
import SeriesItem from 'rebook/apps/catalog/components/SeriesItem';
import AuthorDetailListTitle from 'rebook/apps/catalog/components/AuthorDetailListTitle';
import CatalogItem from 'rebook/apps/catalog/components/CatalogItem';
import throttler from 'rebook/apps/utils/throttler';
import SimilarAuthorHorizontalCard from 'rebook/apps/catalog/components/SimilarAuthorHorizontalCard';
import * as AuthorDetailActions from 'rebook/apps/catalog/actions/AuthorDetailActions';
import * as NotificationActions from 'rebook/apps/users/actions/NotificationActions';
import * as AuthFormActions from 'rebook/apps/users/actions/AuthFormActions';
import pluralize from 'rebook/apps/utils/text/pluralize';
import { Author } from 'rebook/apps/catalog/models';
import TextTruncate from 'rebook/apps/base/components/TextTruncate';
import AuthorDetailHeader from 'rebook/apps/catalog/components/AuthorDetailHeader';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';
import BooksetsCarousel from 'rebook/apps/base/components/BooksetsCarousel';
import { AUTHOR_SUBSCRIBE_MESSAGES } from 'rebook/apps/catalog/constants';

import styles from './style.scss';


const DELAY_BETWEEN_FETCH = 2000;

class AuthorDetailView extends React.Component {
  static fetchInitialDataForServer(match, store) {
    return store.dispatch(AuthorDetailActions.fetchInitialData(match));
  }

  constructor(props) {
    super(props);
    this.state = {
      subType: '',
      showModalWindow: false,
      isLoading: false,
    };
  }
  componentDidMount() {
    const { match, location } = this.props;
    // componentDidMount is never called server side
    // so we fetch data for client here
    this.props.AuthorDetailActions.fetchInitialData(match, location);
  }

  componentDidUpdate(prevProps) {
    const { match, location } = this.props;
    const authorSlug = match.params.authorSlug;

    if (authorSlug && authorSlug !== prevProps.match.params.authorSlug) {
      this.props.AuthorDetailActions.resetData();
      this.props.AuthorDetailActions.fetchInitialData(match, location);
    }
  }

  componentWillUnmount() {
    this.props.AuthorDetailActions.resetData();
  }

  fetchAuthorDetail() {
    const { subType } = this.state;
    this.props.AuthorDetailActions.fetchDetail(this.props.match)
      .then(() => {
        if (subType === 'sub') {
          this.props.NotificationActions.pop(AUTHOR_SUBSCRIBE_MESSAGES.SUBSCRIBE_SUCCESS);
        }
        if (subType === 'unsub') {
          this.props.NotificationActions.pop(AUTHOR_SUBSCRIBE_MESSAGES.UNSUBSCRIBE_SUCCESS);
        }
        this.setState({ isLoading: false });
      })
      .catch(() => {
        this.setState({ isLoading: false });
        this.props.NotificationActions.pop(AUTHOR_SUBSCRIBE_MESSAGES.ERROR, 'error');
      });
  }

  subscribe() {
    const { authorDetail } = this.props;
    this.props.AuthorDetailActions.fetchSubscribeUserToAuthor()
      .then(() => {
        ga('send', 'event', {
          eventCategory: 'ContentSubscription',
          eventAction: 'PushButtonAuthor',
          eventLabel: authorDetail.author.cover_name,
        });
        yaMetrikaReachGoal('SubscribeAuthor');
        throttler(this.fetchAuthorDetail.bind(this), DELAY_BETWEEN_FETCH);
        return null;
      })
      .catch(() => {
        this.setState({ isLoading: false });
        this.props.NotificationActions.pop(AUTHOR_SUBSCRIBE_MESSAGES.ERROR, 'error');
      });
  }

  unsubscribe() {
    const { authorDetail } = this.props;
    this.props.AuthorDetailActions.fetchUnsubscribeUserToAuthor()
      .then(() => {
        ga('send', 'event', {
          eventCategory: 'ContentSubscription',
          eventAction: 'UnsubscribeAuthor',
          eventLabel: authorDetail.author.cover_name,
        });
        throttler(this.fetchAuthorDetail.bind(this), DELAY_BETWEEN_FETCH);
        return null;
      })
      .catch(() => {
        this.setState({ isLoading: false });
        this.props.NotificationActions.pop(AUTHOR_SUBSCRIBE_MESSAGES.ERROR, 'error');
      });
  }

  addToFavorite() {
    const { isLoading } = this.state;
    const { user, authorDetail } = this.props;
    if (isLoading) {
      return null;
    }

    if (!user) {
      this.props.AuthFormActions.showForm();
      return null;
    }
    if (user && user.is_fake_email) {
      this.setState({ showModalWindow: true });
      return null;
    }
    if (authorDetail.isFollowedByUser) {
      this.setState({ isLoading: true, subType: 'unsub' });
      this.unsubscribe();
      return null;
    }
    else {
      this.setState({ isLoading: true, subType: 'sub' });
      this.subscribe();
      return null;
    }
  }

  closeWindow() {
    this.setState({ showModalWindow: false });
  }

  handleClickToSettingsLink() {
    document.querySelector('body').classList.remove('isNotScrollable');
    const { authorDetail } = this.props;
    ga('send', 'event', {
      eventCategory: 'ContentSubscription',
      eventAction: 'GoToMail',
      eventLabel: authorDetail.author.cover_name,
    });
  }

  getModalWindow() {
    return (
      <ModalDialog
        fullSizeForSmall
        extraClassname={styles.modalWindowContainer}
        onClose={() => {
          this.closeWindow();
        }}
        dialog={
          {
            id: '1',
            content:
              <div className={classNames(styles.unavailableInformationWindow, 'jest-unavailable-book-modal-window')}>
                <div className={styles.modalWindowHeader}>
                  <div className={styles.modalWindowHeaderText}>
                    <span>
                      Добавьте электронную почту в ваш профиль
                    </span>
                  </div>
                </div>
                <div className={styles.modalWindowText}>
                  <span>
                    Чтобы получать уведомления о новых книгах, пожалуйста, оставьте нам почту
                  </span>
                </div>
                <Button theme="secondary" link="/account/edit/"
                  extraClassName={styles.linkToSettingsButton}
                  handleClick={() => { this.handleClickToSettingsLink(); }}>
                  <span className={styles.settingsLinkText}>
                    В настройки
                  </span>
                </Button>
              </div>,
          }
        } />
    );
  }

  render() {
    const { showModalWindow, isLoading } = this.state;
    const { user } = this.props;
    const {
      author, books, totalBookCount, audiobooks, totalAudioBookCount,
      series, booksets, similarAuthors, isFollowedByUser,
    } = this.props.authorDetail;
    const theAuthor = new Author(author);
    const modalWindow = this.getModalWindow();

    return (
      <React.Fragment>
        {showModalWindow && modalWindow}
        <div className="section">
          <BreadCrumbs links={[
            { text: 'Библиотека', url: '/catalog/' },
            { text: get(author, 'cover_name', ''), url: get(author, 'absolute_url', '') },
          ]} />
        </div>

        {author && (
          <div className="backgroundContainer themeGrey">
            <AuthorDetailHeader authorUrl={author.share_url} photo={author.photo}
              isLoading={isLoading}
              isFollowedByUser={isFollowedByUser}
              user={user}
              handleAddToFavorite={() => { this.addToFavorite(); }}
              name={author.cover_name}
              booksCount={author.active_book_count} />
            <div className="section">
              {(author.html_description || author.description) && (
                <section className={classNames(styles.container, styles.containerAbout)}>
                  <h3>Об авторе</h3>
                  <TextTruncate
                    expandLabel="Читать полностью"
                    collapseLabel="Свернуть">
                    {ReactHtmlParser(author.html_description || author.description)}
                  </TextTruncate>
                </section>
              )}
              {get(books, 'length', 0) > 0 && (
                <div className={styles.container}>
                  <AuthorDetailListTitle
                    count={totalBookCount}
                    type="book"
                    title="Все книги автора"
                    linkUrl={theAuthor.getBookListUrl()} />
                  <ContentCarousel>
                    {books.map((item) => (
                      <VerticalBookCard key={item.id} book={item} />
                    ))}
                  </ContentCarousel>
                </div>
              )}
              {get(audiobooks, 'length', 0) > 0 && (
                <div className={styles.container}>
                  <AuthorDetailListTitle
                    count={totalAudioBookCount}
                    type="audiobook"
                    title="Все аудиокниги автора"
                    linkUrl={theAuthor.getAudioBookListUrl()} />
                  <ContentCarousel>
                    {audiobooks.map((item) => (
                      <VerticalBookCard key={item.id} book={item} />
                    ))}
                  </ContentCarousel>
                </div>
              )}
              {series && series.objects.length > 0 && (
                <div className={styles.container}>
                  <AuthorDetailListTitle
                    count={series.meta.total_count}
                    type="series"
                    title="Серии с книгами автора" />
                  <ContentCarousel visibleElements="3">
                    {series.objects.map((item) => (
                      <SeriesItem series={item} key={item.id} />
                    ))}
                  </ContentCarousel>
                </div>
              )}
              {booksets && booksets.objects.length > 0 && (
                <BooksetsCarousel
                  title="Подборки с книгами автора"
                  booksets={booksets.objects}
                  booksetsCount={booksets.meta.total_count} />
              )}
              <div className={styles.authorLinksContainer}>
                {author.reviews_count > 0 && (
                  <div className={styles.authorListLink}>
                    <Link to={theAuthor.getReviewListLink()}>
                      <CatalogItem withArrow>
                        <div className="title-3">Отзывы на книги</div>
                        <div className={styles.authorListCount}>
                          {author.reviews_count} {pluralize(author.reviews_count, 'отзыв', 'отзыва', 'отзывов')}
                        </div>
                      </CatalogItem>
                    </Link>
                  </div>
                )}
                {author.citations_count > 0 && (
                  <div className={styles.authorListLink}>
                    <Link to={theAuthor.getCitationListUrl()}>
                      <CatalogItem withArrow>
                        <div className="title-3">Цитаты из книг</div>
                        <div className={styles.authorListCount}>
                          {author.citations_count} {pluralize(author.citations_count, 'цитата', 'цитаты', 'цитат')}
                        </div>
                      </CatalogItem>
                    </Link>
                  </div>
                )}
              </div>
              {similarAuthors && similarAuthors.length > 0 && (
                <div className={styles.similarAuthorListLink}>
                  <AuthorDetailListTitle
                    type="authors"
                    title="Похожие авторы" />
                  <ContentCarousel
                    visibleElements="3"
                    spaceBetween={36}>
                    {similarAuthors.map((item) => {
                      return (
                        <SimilarAuthorHorizontalCard
                          key={`${item.cover_name}-${item.id}`}
                          author={item} />
                      );
                    })}
                  </ContentCarousel>
                </div>
              )}
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

AuthorDetailView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      authorSlug: PropTypes.string.isRequired,
    }),
  }),
};

function mapStateToProps(state) {
  return {
    authorDetail: state.authorDetail,
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    AuthorDetailActions: bindActionCreators(AuthorDetailActions, dispatch),
    NotificationActions: bindActionCreators(NotificationActions, dispatch),
    AuthFormActions: bindActionCreators(AuthFormActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthorDetailView);
